/** Id of the Project Manager agent */ export const projectManagerAgentId = "CopilotResourceId";
